import { useEffect } from "react";
import { useState } from "react";
import {
  Col,
  Row,
  Form,
  Input,
  Label,
  Button,
  Spinner,
  Card,
  CardBody,
} from "reactstrap";
import ExperienceModal from "./ExperienceModal";
import QualificationModal from "./QualificationModal";
import { useDispatch, useSelector } from "react-redux";
import { updateProfile } from "../../../../actions/customer";
import { CustomSnackbar } from "../../../../helpers/CustomSnackbar";
import {
  authKey_local_storage_key,
  getDropdownOptions,
  getSettingByKey,
  getWorkExpText,
  toArray,
  userInfo_local_storage_key,
} from "../../../../helpers/common";
import QualificationJourney from "./QualificationJourney";
import ExperienceJourney from "./ExperienceJourney";
import DocAttachments from "./DocAttachments";
import ImageUploader from "../../../../helpers/Common/ImageUploader";
import AddMoreDetails from "./AddMoreDetails";
import SearchableDropdown from "../../../../helpers/Common/SearchableDropdown";
import useProfileCompletion from "../../../../helpers/Common/useProfileCompletion";
import Certifications from "./Certifications";
import CertificationModal from "./Certifications/CertificationModal";
import ChangeLoginFieldModal from "../../../../helpers/Common/ChangeLoginFieldModal";
import { useSearchParams } from "react-router-dom";
import { getJobIndustries } from "../../../../api/categories";
import { uploadResume } from "../../../../api/customer";
import { getFrontendSettings } from "../../../../api/settings";
import { getCategories } from "../../../../api/categories";
import Avatar from "../../../../assets/images/avatar.png";
import axios from "axios";

const UpdateProfile = () => {
  console.log(
    "LOCAL STORAGE AFTER UPDATE:",
    JSON.parse(localStorage.getItem(userInfo_local_storage_key)),
  );
  console.log("KEY NAME:", userInfo_local_storage_key);
  const [loading, setLoading] = useState(false);

  const { getProfileCompletion, hasCompletedRequiredFields } =
    useProfileCompletion();
  const [jobTypes, setJobTypes] = useState([]);
  const [searchParams] = useSearchParams();
  const isInternal = searchParams.get("isInternal");
  const [errors, setErrors] = useState({});
  const [openQualificationModal, setOpenQualificationModal] = useState(false);
  const [qualificationModalType, setQualificationModalType] = useState("add");
  const [qualificationData, setQualificationData] = useState(null);

  const [openExperienceModal, setOpenExperienceModal] = useState(false);
  const [experienceModalType, setExperienceModalType] = useState("add");
  const [experienceData, setExperienceData] = useState(null);

  const [openCertificationModal, setOpenCertificationModal] = useState(false);
  const [certificationModalType, setCertificationModalType] = useState("add");
  const [certificationData, setCertificationData] = useState(null);

  const [openChangeEmailModal, setOpenChangeEmailModal] = useState(false);
  const [openChangeMobileModal, setOpenChangeMobileModal] = useState(false);
  const [salaryOptions, setSalaryOptions] = useState([]);
  const [experienceOptions, setExperienceOptions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);

  const handleOpenQualificationModal = (type, data = null) => {
    setOpenQualificationModal(true);
    setQualificationModalType(type);
    setQualificationData(data);
  };

  const handleOpenExperienceModal = (type, data = null) => {
    setOpenExperienceModal(true);
    setExperienceModalType(type);
    setExperienceData(data);
  };

  const handleOpenCertificationModal = (type, data = null) => {
    setOpenCertificationModal(true);
    setCertificationModalType(type);
    setCertificationData(data);
  };

  const handleChangeEmail = () => {
    setOpenChangeEmailModal(true);
  };

  const handleChangeMobile = () => {
    setOpenChangeMobileModal(true);
  };

  const handleEmailChangeSuccess = (newEmail) => {
    setFormData({ ...formData, email: newEmail });
    CustomSnackbar.success("Email updated successfully!");
  };

  const handleMobileChangeSuccess = (newMobile) => {
    setFormData({ ...formData, mobile_number: newMobile });
    CustomSnackbar.success("Mobile number updated successfully!");
  };

  const { qualifications, experiences } = useSelector(
    (state) => state.customer,
  );

  const token = localStorage.getItem(authKey_local_storage_key);

  const jobLocations = useSelector((state) => state.jobLocations.data) || [];
  const settings = useSelector((state) => state.settings.data);

  const jobDesignationList = toArray(
    getSettingByKey(settings, "job_designations")?.value,
    "\n",
  );

  const workExperienceList = toArray(
    getSettingByKey(settings, "total_work_experiences")?.value,
    "\n",
  );

  const jobTypeList = toArray(
    getSettingByKey(settings, "job_types")?.value,
    "\n",
  );

  const companyEmailAddress = getSettingByKey(
    settings,
    "company_email_address",
  )?.value;

  const { profile } = useSelector((state) => state.customer);

  const additional_fields = profile?.additional_fields
    ? JSON.parse(profile?.additional_fields) // 👈 throws if already an object, crashes the render
    : {};
  const dispatch = useDispatch();
  const onValueChange = (e, name) => {
    const value = e?.target ? e.target.value : e;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const [formData, setFormData] = useState({});
  const [uploadedResumeName, setUploadedResumeName] = useState("");
  const [uploadedProfileImage, setUploadedProfileImage] = useState("");
  const handleViewResume = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem(authKey_local_storage_key);

      const response = await axios.get(
        `https://sdsjobseekers.runasp.net/api/Candidate/${profile.id}/download-resume`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        },
      );

      const contentType = response.headers["content-type"] || "application/pdf";
      const blob = new Blob([response.data], { type: contentType });
      const blobUrl = window.URL.createObjectURL(blob);

      if (contentType.includes("pdf") || contentType.includes("image")) {
        window.open(blobUrl, "_blank", "noopener,noreferrer");
      } else {
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "resume";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        CustomSnackbar.error(
          "This file type can't be previewed in-browser — downloaded instead.",
        );
      }

      // Free the blob URL once it's no longer needed
      setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
    } catch (err) {
      console.error("View resume failed:", err);
      CustomSnackbar.error("Unable to load resume for viewing.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (profile && profile.data) {
      const profileData = profile.data;

      console.log("========== PROFILE DATA ==========");
      console.log(profileData);

      setUploadedResumeName(profileData.resumeFile || "");
      setUploadedProfileImage(profileData.profileImage || "");

      const initial_state = {
        firstName: profileData.firstName || "",
        lastName: profileData.lastName || "",
        name: profileData.fullName || profileData.name || "",
        email: profileData.email || "",
        fathers_name: profileData.fatherName || "",
        date_of_birth: profileData.dateOfBirth || "",
        // designation: profileData.designation || "",
        gender: profileData.gender || "",
        maritalStatus: profileData.maritalStatus || "",
        workType: profileData.workType?.toString() || "",
        total_work_experience:
          profileData.totalWorkExperience?.toString() || "",
        location: profileData.location || "",
        mobile_number: profileData.phoneNumber || "",
        additionalNumber: profileData.additionalNumber || "",
        current_salary_per_month: profileData.currentSalaryStr || "",
        expectedSalaryStr: profileData.expectedSalaryStr || "",
        // expected_salary_per_month: profileData.currentSalaryStr || "",
        details: profileData.details || "",
        facebook_url: profileData.facebookUrl || "",
        twitter_url: profileData.twitterUrl || "",
        linkedin_url: profileData.linkedinUrl || "",
        whatsapp_number: profileData.whatsappNumber || "",

        languagesknow: profileData.languagesknow
          ? profileData.languagesknow.split(",").filter(Boolean)
          : [],

        permanentAddress: profileData.permanentAddress
          ? profileData.permanentAddress.split(",").filter(Boolean)
          : [],

        state: profileData.state
          ? profileData.state.split(",").filter(Boolean)
          : [],
        skills: profileData.skills || "",
        hobbies: profileData.hobbies || "",

        // IMPORTANT
        resumeFile: profileData.resumeFile || "",
        profileImage: profileData.profileImage || "",

        // 🎯 NEW: fields added to payload (initial values from profile, if present)
        designation: profileData.designation || "",
        jobInduestry: profileData.jobInduestry || "",
        currentSalaryStr: profileData.currentSalaryStr || "",
        maximumSalaryPerMonth: profileData.maximumSalaryPerMonth || "",
      };

      console.log("========== INITIAL FORM ==========");
      console.log(initial_state);

      setFormData(initial_state);
    }
  }, [profile]);

  useEffect(() => {
    setApiLoading(true);
    getCategories()
      .then((res) => {
        const arrayData = res?.data?.data || [];
        setCategories(arrayData);
      })
      .catch((err) => {
        console.error("Categories fetch error:", err);
      })
      .finally(() => {
        setApiLoading(false);
      });
  }, []);

  useEffect(() => {
    getJobIndustries()
      .then((res) => {
        const parsedTypes = Array.isArray(res)
          ? res
          : res?.data?.data || res?.data || [];
        setJobTypes(parsedTypes);
      })
      .catch((err) => {
        console.error("Error direct-fetching job industries:", err);
      });
  }, []);

  useEffect(() => {
    const fetchFrontendDropdownSettings = async () => {
      try {
        const response = await getFrontendSettings();
        const rawData = Array.isArray(response.data)
          ? response.data
          : response.data?.data || [];

        // 1. Process Total Work Experiences Array Setup
        const expSetting = rawData.find(
          (item) => item.key === "total_work_experiences",
        );
        if (expSetting && expSetting.value) {
          const parsedExp = expSetting.value
            .split(/\r?\n/)
            .map((opt) => opt.trim())
            .filter((opt) => opt.length > 0);
          setExperienceOptions(parsedExp);
        }

        // 2. Process Salary Ranges Array Setup
        const salarySetting = rawData.find(
          (item) => item.key === "salary_range",
        );
        if (salarySetting && salarySetting.value) {
          const parsedSalary = salarySetting.value
            .split(/\r?\n/)
            .map((opt) => opt.trim())
            .filter((opt) => opt.length > 0);
          setSalaryOptions(parsedSalary);
        }
      } catch (error) {
        console.error(
          "Error setting dynamic dropdown configuration options:",
          error,
        );
      }
    };

    fetchFrontendDropdownSettings();
  }, []);

  const onChangeValue = (e, name) => {
    const value = e?.target ? e.target.value : e;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onNumberInputChange = (e, name) => {
    const inputValue = e.target.value;
    if (!inputValue) {
      setFormData({ ...formData, [name]: "" });
      return;
    }

    if (!/^\d+$/.test(inputValue)) return;
    setFormData({ ...formData, [name]: inputValue });
  };

  const updateProfileHandle = async (newProfilePic) => {
    setLoading(true);
    handleResumeUpload();

    // 1. Profile Pic state sync
    let finalProfileImage = uploadedProfileImage;

    if (newProfilePic) {
      finalProfileImage = newProfilePic;
      setUploadedProfileImage(newProfilePic);
    }

    // 2. Construct Payload including AddMoreDetails fields
    const payload = {
      firstName: formData?.firstName || "",
      lastName: formData?.lastName || "",
      additionalNumber: formData?.additionalNumber || "",
      profileImage: finalProfileImage || "",
      gender: formData?.gender || "",
      dateOfBirth: formData?.date_of_birth || "",
      location: formData?.location || "",

      // 🎯 THE FIX: single currentSalaryStr key (was duplicated — the second
      // definition below was silently overwriting this one)
      currentSalaryStr:
        formData?.currentSalaryStr || formData?.current_salary_per_month || "",

      // 🎯 THE FIX: this was completely missing from the payload before.
      // UpdateProfile.jsx has no visible field for expectedSalaryStr, so we
      // preserve whatever value already exists on the profile instead of
      // silently wiping it out on every save — this was the actual cause of
      // being bounced back to /compulsary/profile after using this page.
      expectedSalaryStr:
        formData?.expectedSalaryStr || profile?.data?.expectedSalaryStr || "",

      totalWorkExperience: formData?.total_work_experience || "",
      skills: Array.isArray(formData?.skills)
        ? formData.skills.join(", ")
        : formData?.skills || "",

      hobbies: Array.isArray(formData?.hobbies)
        ? formData.hobbies.join(", ")
        : formData?.hobbies || "",

      details: formData?.details || "",
      presantAddress: formData?.present_address || "",

      languagesknow: Array.isArray(formData?.languagesknow)
        ? formData.languagesknow.join(",")
        : formData.languagesknow || "",

      // 🎯 THE FIX: single permanentAddress key (was duplicated)
      permanentAddress: Array.isArray(formData?.permanentAddress)
        ? formData.permanentAddress.join(",")
        : formData.permanentAddress || "",

      // 🎯 THE FIX: single state key (was duplicated)
      state: Array.isArray(formData?.state)
        ? formData.state.join(",")
        : formData.state || "",

      facebookUrl: formData?.facebook_url || "",
      twitterUrl: formData?.twitter_url || "",
      whatsappNumber: formData?.whatsapp_number || "",
      linkedinUrl: formData?.linkedin_url || "",

      resumeFile:
        typeof formData?.resumeFile === "string"
          ? formData?.resumeFile
          : uploadedResumeName || "",

      designation: formData?.designation || "",
      jobInduestry: formData?.jobInduestry || "",

      qualifications: qualifications?.length
        ? JSON.stringify(qualifications)
        : "",
      additionalFields: JSON.stringify({
        same_as_permanent_address: formData?.same_as_permanent_address || "No",
      }),
    };

    console.log("========== FINAL UPDATE PAYLOAD ==========");
    console.log(payload);

    console.log("TYPE OF RESUME:", typeof payload.resumeFile);
    console.log("RESUME VALUE:", payload.resumeFile);

    console.log("TYPE OF PROFILE IMAGE:", typeof payload.profileImage);
    console.log("PROFILE IMAGE VALUE:", payload.profileImage);
    dispatch(updateProfile({ ...payload, id: profile.id }))
      .then((res) => {
        setLoading(false);
        if (res && (res.status === 200 || res.success)) {
          CustomSnackbar.success(`Profile updated successfully.`);
        }
      })
      .catch((err) => {
        console.error("DEBUG Error:", err);
        setLoading(false);
      });
  };

  const handleResumeUpload = async () => {
    try {
      if (!formData?.resumeFile) {
        CustomSnackbar.error("Please select resume first");
        return;
      }

      // only File object allowed
      if (!(formData.resumeFile instanceof File)) {
        console.log("OLD RESUME EXISTS");

        CustomSnackbar.success("Resume already uploaded");
        return;
      }

      setLoading(true);

      const formPayload = new FormData();

      formPayload.append("file", formData.resumeFile);

      console.log("========== FORM DATA ==========");

      for (let pair of formPayload.entries()) {
        console.log(pair[0], pair[1]);
      }

      const token = localStorage.getItem(authKey_local_storage_key);

      const res = await axios.post(
        "https://sdsjobseekers.runasp.net/api/CandidateAttachment/UploadResume",
        formPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      console.log("========== RESUME RESPONSE ==========");
      console.log(res.data);

      if (res?.status === 200) {
        const uploadedFileName =
          res?.data?.fileName || res?.data?.data?.fileName || res?.data?.name;

        console.log("UPLOADED FILE NAME:", uploadedFileName);

        if (uploadedFileName) {
          setUploadedResumeName(uploadedFileName);

          setFormData((prev) => ({
            ...prev,
            resumeFile: uploadedFileName,
          }));
        }

        CustomSnackbar.success("Resume uploaded successfully");
      }
    } catch (err) {
      console.log("========== RESUME ERROR ==========");
      console.log(err);

      console.log("ERROR RESPONSE:", err?.response);

      CustomSnackbar.error(
        err?.response?.data?.message || "Resume upload failed",
      );
    } finally {
      setLoading(false);
    }
  };
  console.log("updateprofileimg*", updateProfileHandle);

  console.log("📦 formData:", formData);
  console.log("📄 resumefile:", formData.resumeFile);
  console.log("🔍 type:", typeof formData.resumeFile);
  const onSubmit = (e) => {
    e.preventDefault();

    if (!formData.firstName) {
      CustomSnackbar.error("Please enter your First Name");
      return;
    }
    if (!formData.lastName) {
      CustomSnackbar.error("Please enter your Last Name");
      return;
    }

    if (!formData.email) {
      CustomSnackbar.error("Please enter your email address");
      return;
    }

    if (!formData.mobile_number) {
      CustomSnackbar.error("Please enter your mobile number");
      return;
    }

    if (!formData.date_of_birth) {
      CustomSnackbar.error("Please enter your date of birth");
      return;
    }

    if (!formData?.gender) {
      CustomSnackbar.error("Please select your gender");
      return;
    }

    if (!formData.designation && !isInternal) {
      CustomSnackbar.error("Please enter your designation");
      return;
    }

    if (!formData.location && !isInternal) {
      CustomSnackbar.error("Please enter your location");
      return;
    }

    if (!formData.currentSalaryStr && !isInternal) {
      CustomSnackbar.error("Please enter your  Salary.");
      return;
    }
    if (!formData.jobInduestry && !isInternal) {
      CustomSnackbar.error("Please enter your  Job Industry.");
      return;
    }

    if (!formData.total_work_experience && !isInternal) {
      CustomSnackbar.error("Please select your work Experience.");
      return;
    }

    if (!formData.resumeFile && !isInternal) {
      CustomSnackbar.error("Please a Upload a resume it's a Compulsary");
      return;
    }

    setLoading(true);
    updateProfileHandle();
  };

  const maxDateAllowed = new Date(
    new Date().setFullYear(new Date().getFullYear() - 18),
  )
    .toISOString()
    .split("T")[0];

  return (
    <div id="profile-form">
      <Form onSubmit={onSubmit}>
        {/* PROFILE PICTURE SECTION */}
        <div className="mb-4 text-center">
          <ImageUploader
            uploadPath="/CandidateAttachment"
            assetType="customers"
            updateImageHandle={updateProfileHandle}
            imageName={
              profile?.data?.profileImage || additional_fields?.profile_picture
            }
            placeholderImage={Avatar}
          />
        </div>

        {/* CARD 1: BASIC DETAILS */}
        <Card className="border-0 shadow-sm rounded-4 mb-4">
          <CardBody className="p-4">
            <h5 className="fs-17 fw-semibold mb-4 text-primary">
              <i className="uil uil-user-circle me-2"></i>Basic Details
            </h5>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <label htmlFor="firstName" className="form-label">
                    First Name *
                  </label>
                  <Input
                    data-score={3}
                    type="text"
                    id="firstName"
                    placeholder="Enter your First name"
                    value={formData.firstName}
                    onChange={(e) => onChangeValue(e, "firstName")}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label htmlFor="lastName" className="form-label">
                    Last Name *
                  </label>
                  <Input
                    data-score={3}
                    type="text"
                    id="lastName"
                    placeholder="Enter your Last name"
                    value={formData.lastName}
                    onChange={(e) => onChangeValue(e, "lastName")}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="date_of_birth" className="form-label">
                    Date of birth *
                  </Label>
                  <Input
                    data-score={3}
                    type="date"
                    id="date_of_birth"
                    value={formData.date_of_birth}
                    onChange={(e) => onChangeValue(e, "date_of_birth")}
                    max={maxDateAllowed}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="gender" className="form-label">
                    Gender *
                  </Label>
                  <SearchableDropdown
                    placeholder="Select your gender"
                    options={[
                      { label: "Male", value: "Male" },
                      { label: "Female", value: "Female" },
                      { label: "Transgender", value: "Transgender" },
                    ]}
                    value={formData.gender}
                    onChange={(value) =>
                      setFormData({ ...formData, gender: value?.toString() })
                    }
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="email" className="form-label">
                    Email *
                  </Label>
                  <div className="d-flex">
                    <Input
                      disabled
                      value={formData.email}
                      className="bg-light"
                    />
                    <Button
                      color="outline-primary"
                      size="sm"
                      className="ms-2"
                      onClick={handleChangeEmail}
                      title="Change Email"
                    >
                      <i className="uil uil-pen"></i>
                    </Button>
                  </div>
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="mobile" className="form-label">
                    Mobile Number *
                  </Label>
                  <div className="d-flex">
                    <Input
                      disabled
                      value={formData.mobile_number}
                      className="bg-light"
                    />
                    <Button
                      color="outline-primary"
                      size="sm"
                      className="ms-2"
                      onClick={handleChangeMobile}
                      title="Change Mobile Number"
                    >
                      <i className="uil uil-pen"></i>
                    </Button>
                  </div>
                </div>
              </Col>
              <Col lg={12}>
                <div className="mb-3">
                  <Label htmlFor="additionalNumber" className="form-label">
                    Phone Number (Optional)
                  </Label>
                  <Input
                    type="text"
                    id="additionalNumber"
                    placeholder="Enter your Phone number"
                    value={formData.additionalNumber}
                    onChange={(e) => onChangeValue(e, "additionalNumber")}
                  />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* CARD 2: PROFESSIONAL DETAILS */}
        <Card className="border-0 shadow-sm rounded-4 mb-4">
          <CardBody className="p-4">
            <h5 className="fs-17 fw-semibold mb-4 text-primary">
              <i className="uil uil-briefcase-alt me-2"></i>Professional Details
            </h5>
            <Row>
              <Col lg={6}>
                <div className="mb-4">
                  <Label htmlFor="jobtitle" className="form-label fw-semibold">
                    Job Title / Designation *
                  </Label>
                  <div
                    className={
                      errors.designation
                        ? "is-invalid custom-dropdown-error"
                        : ""
                    }
                  >
                    <SearchableDropdown
                      options={getDropdownOptions(categories, {
                        label: "name",
                        value: "name",
                      })}
                      value={formData.designation}
                      onChange={(val) => onValueChange(val, "designation")}
                      placeholder="Select or Enter Job Title"
                      leftIcon={<i className="uil uil-briefcase-alt me-4"></i>}
                      isCreatable={true}
                      sortOptionsAlphabetically
                      isLoading={apiLoading}
                    />
                  </div>
                  {errors.designation && (
                    <div className="invalid-feedback d-block mt-1">
                      Please select a title
                    </div>
                  )}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <label
                    htmlFor="choices-single-location"
                    className="form-label"
                  >
                    Your Location *
                  </label>
                  <SearchableDropdown
                    placeholder="Select location"
                    options={getDropdownOptions(jobLocations)}
                    value={formData.location}
                    sortOptionsAlphabetically
                    onChange={(value) =>
                      setFormData({ ...formData, location: value?.toString() })
                    }
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="total_work_experience" className="form-label">
                    Total Work Experience *
                  </Label>
                  <SearchableDropdown
                    placeholder="Select work experience"
                    options={workExperienceList?.map((exp) => ({
                      label: `${getWorkExpText(exp)}`,
                      value: `${exp}`,
                    }))}
                    value={`${formData.total_work_experience || ""}`}
                    onChange={(value) =>
                      setFormData({
                        ...formData,
                        total_work_experience: value?.toString(),
                      })
                    }
                  />
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-4">
                  <Label htmlFor="job-categories" className="form-label">
                    Choose Job Industry *
                  </Label>
                  <Input
                    type="select"
                    className="form-select"
                    id="job-categories"
                    name="jobInduestry"
                    value={formData.jobInduestry}
                    invalid={errors.jobInduestry ? true : false}
                    onChange={(e) => onValueChange(e, "jobInduestry")}
                  >
                    <option value="">--select--</option>
                    {jobTypes.map((type) => (
                      <option
                        key={type.id || type.jobInduestry}
                        value={type.id || type.jobInduestry}
                      >
                        {type.name || type.industryName || type.title}
                      </option>
                    ))}
                  </Input>
                </div>
              </Col>

              <Col lg={6}>


                <div className="mb-4">
                  <Label htmlFor="minSalary" className="form-label">
                    Current Salary Per Month *
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="minSalary"
                    name="currentSalaryStr"
                    placeholder="Enter your current salary"
                    value={formData.currentSalaryStr}
                    invalid={errors.currentSalaryStr ? true : false}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (!value) {
                        setFormData((prev) => ({
                          ...prev,
                          currentSalaryStr: "",
                        }));
                        return;
                      }

                      if (!/^\d+$/.test(value)) return;

                      setFormData((prev) => ({
                        ...prev,
                        currentSalaryStr: value,
                      }));
                    }}
                  />
                </div>
              </Col>

              <Col lg={6}>


                <div className="mb-4">
                  <Label htmlFor="minSalary" className="form-label">
                    Expected Salary Per Month *
                  </Label>
                  <Input
                    type="select"
                    className="form-control form-select"
                    id="minSalary"
                    name="expectedSalaryStr"
                    value={formData.expectedSalaryStr}
                    invalid={errors.expectedSalaryStr ? true : false}
                    onChange={(e) => {
                      const selectedSalary = e.target.value;
                      setFormData((prev) => ({
                        ...prev,
                        expectedSalaryStr: selectedSalary,
                        expectedSalaryStr: selectedSalary,
                      }));
                    }}
                  >
                    <option value="">Select Expected Salary Per Month</option>
                    {salaryOptions.map((salary, index) => (
                      <option key={index} value={salary}>
                        {salary}
                      </option>
                    ))}
                  </Input>
                </div>
              </Col>
            </Row>

            {/* Additional Details Component stays here */}
            <AddMoreDetails
              formData={formData}
              setFormData={setFormData}
              onChangeValue={onChangeValue}
            />
          </CardBody>
        </Card>

        {/* CARD 3: RESUME & ATTACHMENTS */}
        <Card className="border-0 shadow-sm rounded-4 mb-4">
          <CardBody className="p-4">
            <h5 className="fs-17 fw-semibold mb-4 text-primary">
              <i className="uil uil-file-upload-alt me-2"></i> Upload
              Resume
            </h5>
            <Row>
              <Col lg={12}>
                <div className="mb-3">
                  <label
                    htmlFor="resumeFile"
                    className="form-label fw-medium text-dark"
                  >
                    Resume Compulsory *
                  </label>
                  <div className="d-flex gap-2 flex-wrap flex-sm-nowrap">
                    <Input
                      type="file"
                      id="resumeFile"
                      accept=".pdf,.doc,.docx"
                      className="form-control"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (!file) return;
                        setFormData((prev) => ({ ...prev, resumeFile: file }));
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-primary px-4 flex-shrink-0"
                      onClick={handleResumeUpload}
                    >
                      <i className="uil uil-upload me-1"></i> Upload
                    </button>

                    {/* 🟢 DYNAMIC DOWNLOAD ACTION BUTTON */}
                    {/* 🟢 DYNAMIC VIEW ACTION BUTTON — opens inline instead of downloading */}
                    {profile?.id && (
                      <button
                        type="button"
                        onClick={handleViewResume}
                        className="btn btn-outline-secondary px-4 flex-shrink-0 d-inline-flex align-items-center gap-1"
                        title="View current uploaded resume"
                      >
                        <i className="uil uil-eye fs-16"></i> View Resume
                      </button>
                    )}
                  </div>

                  {formData?.resumeFile && (
                    <div className="mt-2 text-success small fw-medium d-flex align-items-center">
                      <i className="uil uil-check-circle me-1 fs-15"></i>
                      <span>
                        <strong>Active Document: </strong>
                        {typeof formData?.resumeFile === "string"
                          ? formData?.resumeFile.split("/").pop()
                          : formData?.resumeFile?.name}
                      </span>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* JOURNEY SECTIONS (Qualifications & Experiences) */}
        <div className="mt-4 px-2">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="fs-17 fw-semibold mb-0 text-primary">
              Qualifications
            </h5>
            <Button
              color="primary"
              onClick={() => handleOpenQualificationModal("add")}
              outline
              size="sm"
            >
              Add Qualification
            </Button>
          </div>
          <QualificationJourney
            handleOpenQualificationModal={handleOpenQualificationModal}
            componentType="update"
          />

          <div className="cust-divider my-4"></div>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="fs-17 fw-semibold mb-0 text-primary">Experiences</h5>
            <Button
              color="primary"
              onClick={() => handleOpenExperienceModal("add")}
              outline
              size="sm"
            >
              Add Experience
            </Button>
          </div>
          <ExperienceJourney
            handleOpenExperienceModal={handleOpenExperienceModal}
            componentType="update"
          />
        </div>

        {/* SUBMIT SECTION */}
        <div className="mt-5 px-2">
          {companyEmailAddress && (
            <p className="text-muted mb-3" style={{ fontSize: "15px" }}>
              Note: Contact support at{" "}
              <a href={`mailto:${companyEmailAddress}`}>
                {companyEmailAddress}
              </a>{" "}
              for account issues.
            </p>
          )}

          <div className="text-end">
            {loading ? (
              <button
                type="button"
                className="btn btn-primary w-100 disabled p-2 fs-16"
              >
                Updating Profile <Spinner size="sm" className="ms-2" />
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-primary w-100 p-2 fs-16 fw-bold"
              >
                Update Profile
              </button>
            )}
          </div>
        </div>
      </Form>

      {/* MODALS (STAY UNCHANGED) */}
      {openQualificationModal && (
        <QualificationModal
          openQualificationModal={openQualificationModal}
          setOpenQualificationModal={setOpenQualificationModal}
          modalType={qualificationModalType}
          qualificationData={qualificationData}
        />
      )}
      {openExperienceModal && (
        <ExperienceModal
          openExperienceModal={openExperienceModal}
          setOpenExperienceModal={setOpenExperienceModal}
          modalType={experienceModalType}
          experienceData={experienceData}
        />
      )}
      {openCertificationModal && (
        <CertificationModal
          openCertificationModal={openCertificationModal}
          setOpenCertificationModal={setOpenCertificationModal}
          modalType={certificationModalType}
          certificationData={certificationData}
        />
      )}

      <ChangeLoginFieldModal
        openModal={openChangeEmailModal}
        setOpenModal={setOpenChangeEmailModal}
        field="email"
        currentValue={formData.email}
        onSuccess={handleEmailChangeSuccess}
      />
      <ChangeLoginFieldModal
        openModal={openChangeMobileModal}
        setOpenModal={setOpenChangeMobileModal}
        field="mobile_number"
        currentValue={formData.mobile_number}
        onSuccess={handleMobileChangeSuccess}
      />
    </div>
  );
};

export default UpdateProfile;
